// Tarayıcı işlem ölçümü (RUM): kullanıcının algıladığı süre + sunucu aşamaları (Server-Timing), tekrarlanan çağrılar.
// Hiçbir koşulda isteği bekletmez veya bozmaz; tüm kod try/catch içinde. Kişisel veri gönderilmez (yalnız işlem adı ve süreler).
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SLOW_MS = 2000;
const ID_SEG = /^(?:[0-9a-fA-F-]{16,}|\d+|[^/]*@[^/]*|[A-Za-z0-9_-]{24,})$/;
const RULES = [
  ['POST', /^\/work-permits$/, 'talep_olusturma'],
  ['PUT', /^\/work-permits\/{id}$/, 'taslak_kaydetme'],
  ['PUT', /^\/work-permits\/{id}\/submit-review$/, 'talep_gonderme'],
  ['GET', /^\/work-permits\/{id}$/, 'inceleme'],
  ['PUT', /^\/work-permits\/{id}\/(approve|reject|finalize|submit-approval|mark-deficient)$/, 'onay_ret'],
  ['POST', /^\/work-permits\/{id}\/send-deficiency-report$/, 'onay_ret'],
  ['POST', /^\/(employees|companies|equipment)\/{id}\/document-files\/[a-z_]+$/, 'belge_yukleme'],
  ['GET', /^\/equipment\/{id}\/document-files\/periyodik_muayene$/, 'periyodik_muayene'],
  ['GET', /^\/(employees|companies|equipment)\/{id}\/document-files\/[a-z_]+$/, 'belge_goruntuleme'],
  ['GET', /^\/(employees|companies|equipment)\/{id}\/document-files\/[a-z_]+\/history$/, 'belge_gecmisi'],
];
const ON = { enabled: true, installed: false };
let sampled = false;
const queue = [];
const recent = new Map();
const reported = new Set();
let repeats = [];
// Ekran süresi için: API meşguliyet birleşimi ve tarayıcının uzun görevleri (yalnız destekleyen tarayıcılarda)
const busy = { n: 0, since: 0, total: 0 };
const longT = { total: 0, supported: false };
export const busyNow = () => busy.total + (busy.n ? performance.now() - busy.since : 0);
export const longNow = () => (longT.supported ? longT.total : null);
const busyStart = () => { if (busy.n++ === 0) busy.since = performance.now(); };
const busyEnd = () => { if (busy.n > 0 && --busy.n === 0) busy.total += performance.now() - busy.since; };
export const isSampled = () => sampled;
export const pushScreen = (ev) => { try { if (ON.enabled && queue.length < 50 && (sampled || ev.ms >= SLOW_MS || ev.tm)) queue.push({ ok: true, st: 0, sampled, ...ev }); } catch { /* yoksay */ } };

const norm = (url) => {
  const path = (url || '').replace(API, '').split('?')[0];
  return path.split('/').map(p => (ID_SEG.test(p) ? '{id}' : p)).join('/');
};
const opId = () => Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
const parseTiming = (h) => {
  const out = {};
  (h || '').split(',').forEach(p => { const m = p.trim().match(/^([a-z]+);dur=([\d.]+)/); if (m) out[m[1]] = parseFloat(m[2]); });
  return out;
};

const trackRepeat = (method, path) => {
  const key = `${method} ${path}`;
  const page = window.location.pathname.split('/').map(p => (ID_SEG.test(p) ? '{id}' : p)).join('/');
  const now = Date.now();
  const arr = (recent.get(key) || []).filter(t => now - t < 10000);
  arr.push(now);
  recent.set(key, arr);
  if (recent.size > 300) recent.clear();
  const tag = `${page}|${key}`;
  if (arr.length >= 3 && !reported.has(tag)) { reported.add(tag); repeats.push({ k: key, n: arr.length }); }
  else if (reported.has(tag)) { const r = repeats.find(x => x.k === key); if (r) r.n = Math.max(r.n, arr.length); }
};

const finish = (config, status, headers) => {
  const m = config.__perf;
  if (!m) return;
  const ms = performance.now() - m.t0;
  const ok = status > 0 && status < 400;
  if (!(sampled || ms >= SLOW_MS || !ok)) return;
  const srv = parseTiming(headers?.['server-timing']);
  const ph = {};
  if (m.up != null) ph.upload = m.up;
  if (srv.total != null) {
    ph.srv_total = srv.total;
    let known = 0;
    [['parse', 'srv_parse'], ['validate', 'srv_validate'], ['pdf', 'srv_pdf'], ['storage', 'srv_storage'], ['db', 'srv_db']].forEach(([k, n]) => { if (srv[k] != null) { ph[n] = srv[k]; known += srv[k]; } });
    if (known) ph.srv_other = Math.max(0, srv.total - known);
    // Yüklemede sunucunun alma/ayrıştırma süresi dosya aktarımıyla eşzamanlıdır; iki kez sayılmaz
    ph.net_wait = Math.max(0, m.up != null ? ms - m.up - (srv.total - (srv.parse || 0)) : ms - srv.total);
  }
  if (queue.length < 50) queue.push({ a: m.action, ms, ok, st: status, sampled, ph });
};

const flush = () => {
  try {
    if (!ON.enabled || (!queue.length && !repeats.length)) return;
    const auth = axios.defaults.headers.common.Authorization;
    if (!auth) return;
    const body = JSON.stringify({ events: queue.splice(0, 50), repeats: repeats.splice(0, 30) });
    fetch(`${API}/perf/rum`, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', Authorization: auth }, body })
      .then(r => (r.ok ? r.json() : null)).then(d => { if (d && d.enabled === false) ON.enabled = false; }).catch(() => {});
  } catch { /* ölçüm hatası uygulamayı etkilemez */ }
};

export const installPerfRum = () => {
  if (ON.installed) return;
  ON.installed = true;
  try {
    const s = sessionStorage.getItem('perf_rum_sampled');
    sampled = s ? s === '1' : Math.random() < 0.1;
    sessionStorage.setItem('perf_rum_sampled', sampled ? '1' : '0');
  } catch { sampled = false; }
  axios.interceptors.request.use((config) => {
    try {
      if (!ON.enabled || !(config.url || '').startsWith(API) || config.url.startsWith(`${API}/perf/`) || config.url.startsWith(`${API}/platform-owner/`)) return config;
      const method = (config.method || 'get').toUpperCase();
      const path = norm(config.url);
      trackRepeat(method, path);
      config.__busy = true; busyStart();
      const rule = method === 'GET' && path === '/employees' && /[?&]q=/.test(config.url) ? [method, null, 'personel_arama_api']
        : RULES.find(([m, re]) => m === method && re.test(path));
      if (rule) {
        const meta = { action: rule[2], t0: performance.now(), up: null };
        config.__perf = meta;
        config.headers = config.headers || {};
        config.headers['X-Op-Id'] = opId();
        if (rule[2] === 'belge_yukleme') {
          const prev = config.onUploadProgress;
          config.onUploadProgress = (e) => {
            try { if (e.total && e.loaded >= e.total && meta.up == null) meta.up = performance.now() - meta.t0; } catch { /* yoksay */ }
            if (prev) prev(e);
          };
        }
      }
    } catch { /* yoksay */ }
    return config;
  });
  axios.interceptors.response.use(
    (res) => { try { if (res.config?.__busy) busyEnd(); finish(res.config, res.status, res.headers); } catch { /* yoksay */ } return res; },
    (err) => { try { if (err.config?.__busy) busyEnd(); if (err.config) finish(err.config, err.response?.status || 0, err.response?.headers); } catch { /* yoksay */ } return Promise.reject(err); },
  );
  try {
    if (window.PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes('longtask')) {
      new PerformanceObserver((l) => { l.getEntries().forEach(e => { longT.total += e.duration; }); }).observe({ type: 'longtask', buffered: false });
      longT.supported = true;
    }
  } catch { longT.supported = false; }
  setInterval(flush, 30000);
  document.addEventListener('visibilitychange', () => { if (document.hidden) flush(); });
};
